import Axios from 'axios';

export async function checkLoggedIn() {
    let cookieValid: boolean = false;
    try {
        const response = await Axios.get('/v10/clientconfig');
        // Check if the userName key exists and is not empty
        if (!response.data.userName) {
        // logout
        window.location.href = "/";
        } else {
            // await Axios.get('/v10/cookiemonster');
            cookieValid = true;
        }
    } catch (error) {
        // logout still
        window.location.href = "/";
    }
    if (cookieValid) {
        try {
            await Axios.get('/v10/cookiemonster');
        } catch (error) {
            // it will produce not found as eventservice is not updated
            // for now we dont care for this
        }
    }
}
